<template>
  <el-dialog
      title="医生知情同意书"
      :visible.sync="dialogVisible"
      width="800px"
      class="consent-modal"
      :modal-append-to-body="false"
      :append-to-body="true"
      @close="handleClose">
    <div class="consent-content">
      <div class="consent-item">
        <strong>医生提交案例知情同意与承诺：</strong>
      </div>
      <div class="consent-item">
        本人__________（医师姓名），执业机构__________，郑重声明并同意：
      </div>
      <div class="consent-item">1. 本人自愿向【痛经无忧案例交流项目】提交临床案例，仅用于公益科普、学术交流、项目展示，不涉及任何商业用途。</div>
      <div class="consent-item">2. 本人承诺所提交案例真实、准确、完整，无虚构、篡改、夸大；每位医师仅可投稿一份诊疗案例，不得引用他人案例，严格遵守学术规范，避免抄袭。</div>
      <div class="consent-item">3. 本人已充分告知患者并获得书面/明确同意，允许将诊疗信息用于本公益项目。</div>
      <div class="consent-item">4. 本人已对案例进行脱敏处理，已删除/隐去患者姓名、联系方式、身份证号、家庭住址、病历号、生物识别信息等可识别身份的内容。</div>
      <div class="consent-item">5. 主办方（北京天安公益基金会）有权对案例进行编辑、审核、脱敏、展示与存档，仅在公益范围内使用。</div>
      <div class="consent-item">6. 本人知晓并同意：主办方将履行数据安全与隐私保护义务，严格保密，不向无关第三方泄露。</div>
      <div class="consent-item">7. 本提交为自愿行为，患者或本人可随时申请撤回，主办方将在合理期限内停止使用并做匿名化处理。</div>
      <div class="consent-item">8. 本人确认已阅读并完全理解以上条款，自愿提交并承担相应责任。</div>
    </div>
    <div class="signature-section">
      <div class="signature-line">
        <span class="signature-label">医师签名：</span>
        <span class="signature-input">__________</span>
      </div>
      <div class="signature-line">
        <span class="signature-label">日期：</span>
        <span class="signature-input">__________</span>
      </div>
    </div>
<!--    <span slot="footer" class="dialog-footer">-->
<!--      <el-button @click="handleCancel">取消</el-button>-->
<!--      <el-button type="primary" @click="handleConfirm">同意并提交</el-button>-->
<!--    </span>-->
  </el-dialog>
</template>

<script>
export default {
  name: 'ConsentModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('cancel');
    },
    handleConfirm() {
      this.dialogVisible = false;
      this.$emit('confirm');
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.consent-modal >>> .el-dialog__title {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.consent-content {
  padding: 20px;
  font-size: 14px;
  line-height: 1.8;
}

.consent-item {
  margin-bottom: 15px;
}

.signature-section {
  text-align: right;
  margin-top: 30px;
  padding-right: 20px;
}

.signature-line {
  margin-bottom: 15px;
}

.signature-label {
  margin-right: 10px;
}

.signature-input {
  display: inline-block;
  border-bottom: 1px solid #ccc;
  width: 200px;
  text-align: center;
}
</style>
